import React from "react";

/**
 * PageHeader — standard premium page title block.
 * Use as the first child of a page's main container.
 *
 *   <PageHeader
 *     overline="Oficinas"
 *     title="Ordens de Serviço"
 *     subtitle="Gestão de todos os SOMs em aberto, em curso e concluídos."
 *     actions={<Button>Nova SOM</Button>}
 *   />
 */
export default function PageHeader({ overline, title, subtitle, actions, testid }) {
  return (
    <div
      className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6"
      data-testid={testid}
    >
      <div className="min-w-0">
        {overline && (
          <div className="text-[10px] uppercase tracking-[0.25em] text-ronil-sand font-heading font-bold mb-2">
            {overline}
          </div>
        )}
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-ronil-navy leading-[1.1] truncate">
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-slate-500 mt-2 max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
      {actions && (
        <div className="flex items-center gap-2 flex-wrap">
          {actions}
        </div>
      )}
    </div>
  );
}
